import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../../utils';
import NodeActivityEditor from '../../NodeActivityEditor';
import CommentsIcon from '../../../../public/assets/images/theme-2/icons/asterisk-white.svg';
import SneakPeakIcon from '../../../../public/assets/images/theme-2/icons/toolbar/visible-black.svg';
import {
  ViewSection,
  HeaderUserImage,
  HeaderUserName,
  HeaderRequestFeedback,
  SneakPeak,
  QuestionWrapper,
} from '../styles';
import { EditorHeaderRowLeft, Editor, EditorHeaderRowRight } from '../../NodeActivityEditor/styles';
import ImmersiveReaderButton from '../../ImmersiveReaderButton';

const EvaluationContentTeacherPanel = ({ fileService, type, student, report, data }) => {
  const { name: studentName, image: studentImage } = student;
  const [hasPeaked, setHasPeaked] = useState(false);
  const headerName = studentName;

  if (!report) {
    return null;
  }

  const studentImages = <HeaderUserImage src={getImageUrl(fileService, studentImage, '60x60')} title={studentName} />;

  const { uuid: entityId, state: reportState, type: entityType, body: reportBody, draft: reportDraft } = report;
  const workNotStarted = reportState === 'blank' || !reportBody;
  const workInProgress = reportState === 'active' && reportDraft;

  const toggleReportComments = () => {
    document.dispatchEvent(new CustomEvent('toggleComments', { detail: { entityId, entityType } }));
  };

  const sneakPeak = () => {
    setHasPeaked(true);
  };

  let editorContent = reportBody;
  if (workNotStarted) {
    editorContent = i18n.__('work_not_started');
  } else if (workInProgress && !hasPeaked) {
    editorContent = i18n.__('work_in_progress');
  }

  const headerPanel = (
    <>
      <EditorHeaderRowLeft>
        {studentImages}
        <HeaderUserName>{headerName}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight>
        <ImmersiveReaderButton />
        <HeaderRequestFeedback onClick={toggleReportComments} src={CommentsIcon} />
      </EditorHeaderRowRight>
    </>
  );

  const editorPanel = (
    <Editor
      className="content-section"
      data-selection-entity="evaluationreport"
      data-selection-uuid={report.uuid}
      showStatusText={workNotStarted || (workInProgress && !hasPeaked)}
      dangerouslySetInnerHTML={{ __html: editorContent }}
    />
  );

  const sneakPeakPanel =
    workInProgress && !hasPeaked ? (
      <SneakPeak onClick={sneakPeak} src={SneakPeakIcon}>
        {i18n.__('sneak_peak')}
      </SneakPeak>
    ) : null;

  return (
    <ViewSection>
      <hr />
      <QuestionWrapper dangerouslySetInnerHTML={{ __html: data.placeholder }} />
      <NodeActivityEditor
        type={type}
        headerPanel={headerPanel}
        editorPanel={editorPanel}
        sneakPeakPanel={sneakPeakPanel}
      />
    </ViewSection>
  );
};

export default EvaluationContentTeacherPanel;

EvaluationContentTeacherPanel.propTypes = {
  fileService: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  student: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};
